import React, { useEffect, useState } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import classes from "./DashSidebar.module.scss";
import Avatar from "@mui/material/Avatar";
import SearchIcon from "@mui/icons-material/Search";
import logo from "../../../assets/Images/logoNT.png";
import InsightsIcon from "@mui/icons-material/Insights";
import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import icon1 from "../../../assets/Images/icons/iconhome.svg";
import { useNavigate, useLocation } from "react-router-dom";
import clientsBlackIcon from "../../../assets/Images/icons/clientsIconBlack.svg";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useDispatch, useSelector } from "react-redux";
import { setDashboard } from "../../../Store/Project/ProjectSlice";
import Tooltip from "@mui/material/Tooltip";
import menuOpen from "../../../assets/Images/icons/menuOpen.svg";
import menuClose from "../../../assets/Images/icons/menuClose.svg";

import ProfileModal from "../../../components/Modals/ProfileModal/ProfileModal";
import OtherHousesOutlinedIcon from "@mui/icons-material/OtherHousesOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PortraitRoundedIcon from "@mui/icons-material/PortraitRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Button } from "@mui/material";
import { setCollapsed } from "../../../Store/Project/ProjectSlice";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";

const DashSidebar = () => {
  const collapsed = useSelector((state: any) => state.project.collapsed);
  const [isAdmin, setIsAdmin] = useState<boolean>(true);
  const [open, setOpen] = useState(false);

  // const isAdmin = sessionStorage.getItem("isAdmin")
  useEffect(() => {
    // const storedValue = sessionStorage.getItem("isAdmin");
    // if (storedValue !== null) {
    //   setIsAdmin(JSON.parse(storedValue));
    // } else {
    //   // setIsAdmin(false)
    // }
  }, []);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pathName = useLocation().pathname;
  let profileDetails: any = sessionStorage.getItem("user-details");
  profileDetails = profileDetails
    ? JSON.parse(profileDetails)
    : {
        FullName: "K Chethan",
        Mobile: "9666318914",
        Email: "k.chethan222@gmail.com",
      };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // console.log("isAdmin", isAdmin);
  return (
    <>
      <div className={classes.sidebar}>
        <Sidebar
          collapsed={collapsed}
          width="210px"
          backgroundColor="rgba(158, 205, 210, 1)"
          transitionDuration={600}
          style={{ borderColor: "rgba(158, 205, 210, 1)" }}
        >
          <div className={classes.wrapper}>
            <div className={classes.wrapperTop}>
              <div className={classes.collapse}>
                <div
                  onClick={() => dispatch(setCollapsed(!collapsed))}
                  style={{ cursor: "pointer" }}
                >
                  {/* {collapsed ? (
                    // <ArrowForwardIosIcon fontSize="small" color="action" />
                    <img src={menuOpen} style={{ width: "30px" }} />
                  ) : (
                    // <ArrowBackIosIcon fontSize="small" color="action" />
                    <img src={menuClose} style={{ width: "30px" }} />
                  )} */}
                  {/* <Tooltip title={collapsed ? "Open Menu" : "Close Menu"}> */}
                    <MenuOpenIcon
                      sx={{
                        transform: collapsed ? "rotate(180deg)" : "",
                        transition: "transform 0.4s ease",
                        fontSize: "30px",
                         color:'#006779'
                      }}
                    />
                  {/* </Tooltip> */}
                </div>
              </div>
              <div className={classes.sidebarMenu}>
                <Menu
                  menuItemStyles={{
                    button: {
                      "&:hover": {
                        backgroundColor: "#327b88",
                        color: "white",
                      },
                    },
                  }}
                >
                  <MenuItem
                    active={pathName.includes("/dashboard/home")}
                    icon={
                      <Tooltip title="Home">
                        <OtherHousesOutlinedIcon
                          sx={{
                            color: pathName.includes("/dashboard/home")
                              ? "white"
                              : "",
                            fontSize: "20px",
                          }}
                        />
                      </Tooltip>
                    }
                    onClick={() => navigate("home")}
                    style={{
                      background: pathName.includes("/dashboard/home")
                        ? "rgba(0, 103, 121, 1)"
                        : "",
                      color: pathName.includes("/dashboard/home")
                        ? "white"
                        : "",
                      fontWeight: 400,
                      fontSize: "14px",
                      borderRadius: "12px",
                      margin: "2px 5px",
                    }}
                  >
                    {" "}
                    Home
                  </MenuItem>
                  <MenuItem
                    active={pathName.includes("/dashboard/clients")}
                    icon={
                      <Tooltip title="Client List">
                        <SupervisorAccountOutlinedIcon
                          sx={{
                            color: pathName.includes("/dashboard/clients")
                              ? "white"
                              : "",
                            fontSize: "20px",
                          }}
                        />
                      </Tooltip>
                    }
                    onClick={() => navigate("clients")}
                    style={{
                      background: pathName.includes("/dashboard/clients")
                        ? "rgba(0, 103, 121, 1)"
                        : "",
                      color: pathName.includes("/dashboard/clients")
                        ? "white"
                        : "",
                      fontWeight: 400,
                      fontSize: "14px",
                      borderRadius: "12px",
                      margin: "2px 5px",
                    }}
                  >
                    {" "}
                    Client List
                  </MenuItem>

                  <Menu
                    menuItemStyles={{
                      button: {
                        "&:hover": {
                          backgroundColor: "#327b88",
                          color: "white",
                        },
                      },
                    }}
                    closeOnClick={true}
                  >
                    <SubMenu
                      icon={
                        <Tooltip title="Earnings">
                          <AccountBalanceWalletOutlinedIcon
                            sx={{
                              color: pathName.includes("/dashboard/earnings")
                                ? "white"
                                : "",
                              fontSize: "20px",
                            }}
                          />
                        </Tooltip>
                      }
                      label="Earnings"
                      // onClick={() => navigate("clients/newkyc")}
                      active={pathName.includes("/earnings")}
                      style={{
                        background: pathName.includes("/dashboard/earnings")
                          ? "rgba(0, 103, 121, 1)"
                          : "",
                        color: pathName.includes("/dashboard/earnings")
                          ? "white"
                          : "",
                        fontWeight: 400,
                        fontSize: "14px",
                        borderRadius: "12px",
                        margin: "2px 5px",
                      }}
                    >
                      <div className={classes.submenu}>
                        <div className={classes.subitem}>
                          <MenuItem
                            active={pathName.includes("/earnings/revenue")}
                            // icon={
                            //   <Tooltip title="Revenue Sheet">
                            //     <BarChartOutlinedIcon
                            //       sx={{
                            //         color: pathName.includes(
                            //           "/earnings/revenue"
                            //         )
                            //           ? "white"
                            //           : "",
                            //           fontSize:'20px'
                            //       }}
                            //     />
                            //   </Tooltip>
                            // }
                            onClick={() =>
                              navigate("/dashboard/earnings/revenue")
                            }
                            style={{
                              background: pathName.includes("/earnings/revenue")
                                ? "rgba(0, 103, 121, 1)"
                                : "",
                              color: pathName.includes("/earnings/revenue")
                                ? "white"
                                : "",
                              fontWeight: 400,
                              fontSize: "14px",
                              borderRadius: "12px",

                              margin: "2px 5px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {" "}
                              <BarChartOutlinedIcon
                                sx={{
                                  color: pathName.includes("/earnings/revenue")
                                    ? "white"
                                    : "",
                                  fontSize: "20px",
                                  marginRight: "5px",
                                }}
                              />
                              <p> Revenue Sheet</p>
                            </div>
                          </MenuItem>

                          <MenuItem
                            active={pathName.includes("/earnings/payout")}
                            // icon={
                            //   <Tooltip title="Payout">
                            //     <CreditScoreIcon
                            //       sx={{
                            //         color: pathName.includes("/earnings/payout")
                            //           ? "white"
                            //           : "",
                            //         fontSize: "20px",
                            //       }}
                            //     />
                            //   </Tooltip>
                            // }
                            onClick={() =>
                              navigate("/dashboard/earnings/payout")
                            }
                            style={{
                              background: pathName.includes("/earnings/payout")
                                ? "rgba(0, 103, 121, 1)"
                                : "",
                              color: pathName.includes("/earnings/payout")
                                ? "white"
                                : "",
                              fontWeight: 400,
                              fontSize: "14px",
                              borderRadius: "12px",
                              margin: "2px 5px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {" "}
                              <CreditScoreIcon
                                sx={{
                                  color: pathName.includes("/earnings/payout")
                                    ? "white"
                                    : "",
                                  fontSize: "20px",
                                  marginRight: "5px",
                                }}
                              />
                              <p>Payouts</p>
                            </div>
                          </MenuItem>
                        </div>
                      </div>
                    </SubMenu>
                  </Menu>

                  <MenuItem
                    active={pathName.includes("/dashboard/profile")}
                    icon={
                      <Tooltip title="Profile">
                        <PortraitRoundedIcon
                          sx={{
                            color: pathName.includes("/dashboard/profile")
                              ? "white"
                              : "",
                            fontSize: "20px",
                          }}
                        />
                      </Tooltip>
                    }
                    onClick={() => navigate("profile")}
                    style={{
                      background: pathName.includes("/dashboard/profile")
                        ? "rgba(0, 103, 121, 1)"
                        : "",
                      color: pathName.includes("/dashboard/profile")
                        ? "white"
                        : "",
                      fontWeight: 400,
                      fontSize: "14px",
                      borderRadius: "12px",
                      margin: "2px 5px",
                    }}
                  >
                    {" "}
                    Profile
                  </MenuItem>
                </Menu>
              </div>
            </div>
            {/* 
            <div className={classes.profileContainer}>
              {collapsed ? (
                <>
                  <Tooltip title="Add New Lead">
                    <Button
                      onClick={handleClickOpen}
                      variant="outlined"
                      sx={{
                        borderColor: "rgba(0, 103, 121, 1)",
                        backgroundColor: "rgba(0, 103, 121, 1)",
                        color: "#FFFFFF",
                        borderRadius: "5px",
                        // padding: "8px 5px",
                        width: "20px",
                        textTransform: "none",
                        fontWeight: 500,
                        fontSize: "12px",
                        "&:hover": {
                          backgroundColor: "rgba(0, 103, 121, 1)",
                          borderColor: "rgba(0, 103, 121, 1)",
                          color: "white",
                        },
                      }}
                    >
                      <AddRoundedIcon />
                    </Button>
                  </Tooltip>
                </>
              ) : (
                <>
                  {" "}
                  <p className={classes.profileContainerheader}>Let's start!</p>
                  <p className={classes.profileContainerSubText}>
                    Adding new leads is effortless.
                  </p>
                  <div>
                    <Button
                      startIcon={<AddRoundedIcon />}
                      // onClick={handleClickOpen}
                      variant="outlined"
                      sx={{
                        borderColor: "rgba(0, 103, 121, 1)",
                        backgroundColor: "rgba(0, 103, 121, 1)",
                        color: "#FFFFFF",
                        borderRadius: "5px",
                        padding: "8px 20px",
                        textTransform: "none",
                        fontWeight: 500,
                        fontSize: "12px",
                        "&:hover": {
                          backgroundColor: "rgba(0, 103, 121, 1)",
                          borderColor: "rgba(0, 103, 121, 1)",
                          color: "white",
                        },
                      }}
                    >
                      {" "}
                      Add New Lead
                    </Button>
                  </div>
                </>
              )}
            </div> */}
          </div>
        </Sidebar>
      </div>
      <ProfileModal classes={classes} open={open} handleClose={handleClose} />
    </>
  );
};

export default DashSidebar;
